// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Features2_wrapper__NiF-z","card":"Features2_card__1u_u1","main":"Features2_main__2jWY-","header":"Features2_header__qWV2Y","btn":"Features2_btn__3zkyB"};